import { render, staticRenderFns } from "./OverviewOtherLabour.vue?vue&type=template&id=5a0721ec&scoped=true"
import script from "./OverviewOtherLabour.vue?vue&type=script&lang=js"
export * from "./OverviewOtherLabour.vue?vue&type=script&lang=js"
import style0 from "./OverviewOtherLabour.vue?vue&type=style&index=0&id=5a0721ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0721ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a0721ec')) {
      api.createRecord('5a0721ec', component.options)
    } else {
      api.reload('5a0721ec', component.options)
    }
    module.hot.accept("./OverviewOtherLabour.vue?vue&type=template&id=5a0721ec&scoped=true", function () {
      api.rerender('5a0721ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OverviewOtherLabour.vue"
export default component.exports